import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetMessageResponse } from './get-message-response';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { PostMessageRequest } from './post-message-request';
import { PostMessageResponse } from './post-message-response';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  // apiURL = 'http://localhost:8080';
  apiURL = 'https://nlp-dot-sentiments-co.uc.r.appspot.com';

  constructor(private http: HttpClient) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  getMessages(): Observable<GetMessageResponse> {
    return this.http.get<GetMessageResponse>(this.apiURL + '/api/v1/chat/message')
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  sendMessage(message: PostMessageRequest): Observable<PostMessageResponse> {
    return this.http.post<PostMessageResponse>(this.apiURL + '/api/v1/chat/message', JSON.stringify(message), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if(error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
 }

}
